<!-- components/Loading.vue -->
<template>
    <div class="loading-overlay">
      <div class="loading-spinner">
        <i class="el-icon-loading"></i>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'Loading',
  };
  </script>
  
  <style scoped>
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }
  
  .loading-spinner {
    font-size: 2rem;
    color: #409EFF;
  }
  </style>